import { render, staticRenderFns } from "./edit-symbol.vue?vue&type=template&id=fee64170&scoped=true"
import script from "./edit-symbol.vue?vue&type=script&lang=js"
export * from "./edit-symbol.vue?vue&type=script&lang=js"
import style0 from "./edit-symbol.vue?vue&type=style&index=0&id=fee64170&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee64170",
  null
  
)

export default component.exports